import { render, staticRenderFns } from "./WebRtcPlayer.vue?vue&type=template&id=4c218e98&scoped=true"
import script from "./WebRtcPlayer.vue?vue&type=script&lang=js"
export * from "./WebRtcPlayer.vue?vue&type=script&lang=js"
import style0 from "./WebRtcPlayer.vue?vue&type=style&index=0&id=4c218e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c218e98",
  null
  
)

export default component.exports